import type { ReactNode } from "react";
import "./Layout.module.css";

type AdminLayoutProps = {
  children: ReactNode;
};

const AdminLayout = ({ children }: AdminLayoutProps) => {
  return (
    <div className="app bg-[#00132E] max-w-[550px] mx-auto">
      <div className="pb-16 bg-white min-h-[100dvh]">{children}</div>
    </div>
  );
};

export default AdminLayout;
